(function () {
    'use strict';
    angular
        .module('laekkerAI.tablet')
        .component('productionSettings', {
            controller: 'KitchenProductionSettingsController',
            templateUrl: '/components/production-settings/production-settings.html',
            bindings: {
                'settings': '<',
                'ifShowAllFilterCheckboxes': '<',
                'showSorting': '<'
            }
        });
})();